"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("../base");

var ReportApi =
/** @class */
function (_super) {
  __extends(ReportApi, _super);

  function ReportApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getReports = function (userId, requestOptions) {
      var params = [];

      if (userId) {
        params.push({
          key: "userId",
          value: userId
        });
      }

      return _this.get({
        path: "/reports/getlist",
        requestOptions: requestOptions,
        params: params
      });
    };

    _this.getReport = function (reportId, requestOptions) {
      var params = [];

      if (reportId) {
        params.push({
          key: "reportId",
          value: reportId
        });
      }

      return _this.get({
        path: "/reports/get",
        params: params,
        requestOptions: requestOptions
      });
    };

    _this.saveReport = function (report, requestOptions) {
      return _this.post({
        path: "/reports/add",
        body: report,
        requestOptions: requestOptions
      });
    };

    _this.updateReport = function (reportId, report, requestOptions) {
      var params = [{
        key: "reportId",
        value: reportId
      }];
      return _this.put({
        path: "/reports/update",
        body: report,
        requestOptions: requestOptions,
        params: params
      });
    };

    _this.deleteReport = function (reportId, requestOptions) {
      var params = [{
        key: "reportId",
        value: reportId
      }];
      return _this.delete({
        path: "/reports/delete",
        params: params,
        requestOptions: requestOptions
      });
    };

    return _this;
  }

  return ReportApi;
}(base_1.BaseApi);

exports.ReportApi = ReportApi;